import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition"
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { Zoom } from "slotworks/graphics/animation/base-animations";
import * as TweenJS from "slotworks/utils/tween";
import Point from "slotworks/utils/geom/point";
import { parallel } from "slotworks/utils/race-utils";
import { CenterPivot } from "slotworks/graphics/pixi/group";
import soundManager from "slotworks/sound/sound-manager";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import RevolverWinTransitions from "./revolver-win-transitions";

export default class EnterFreespinsTransition extends RevolverWinTransitions {

    protected glowContainer: PIXI.Container;
    protected glowTweens: TweenJS.Tween[];
    protected glowStack: PIXI.Sprite[] = [];

    public static torchTweens: TweenJS.Tween[] = [];

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetBase();
            parallel([
                // () => Zoom(Layers.CelebrationBackground.container, 0, 3.6, 250, 0, TweenJS.Easing.Linear.None, 0, new Point(0.48, 0.5)),
                () => this.zoomInBaseStacks(350, 3.6),
                () => Zoom(Layers.Prompts.container, 0, 1.15, 250, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.4)),
            ])
                .then(() => {
                    if(!deviceInfo.isDesktop) {
                        deviceInfo.onLayoutChange.add(this.onLayoutChange);
                    }
                    resolve(null);
                });
        });

    }


    public static startTorch = () => setTimeout(() => EnterFreespinsTransition.playTorchAnimation(), 2);

    // Play torch animations and flickering effect to lighting layers
    public static playTorchAnimation() {
            this.clearTorchTweens();
            if (deviceInfo.isDesktop || canvasManager.orientation === Orientation.LANDSCAPE) {
                // Layers.Custom.get("Torches").setScene("freespins").then(() => {
                    Layers.Custom.get("Torches").show();

                    // Get the torch sprites
                    const torchRight = Layers.Custom.get("Torches").getAnimatedSprite("fs_bg_torch_right");
                    if (torchRight) {
                        torchRight.animationSpeed = 0.5;
                        torchRight.scale.set(1, 1);
                        torchRight.loop = true;
                        torchRight.gotoAndPlay(0);
                        torchRight.visible = true;
                    }
                    const torchLeft = Layers.Custom.get("Torches").getAnimatedSprite("fs_bg_torch_left");
                    if (torchLeft) {
                        torchLeft.animationSpeed = 0.5;
                        torchLeft.scale.set(1, 1);
                        torchLeft.loop = true;
                        torchLeft.gotoAndPlay(0);
                        torchLeft.visible = true;
                    }

                    // Get lighting layers for smooth opacity fade effect (should be separate sprites, not the layer itself)
                    const lightingRight = Layers.Custom.get("Torches").getSprite("lighting-right")
                    const lightingLeft = Layers.Custom.get("Torches").getSprite("lighting-left")

                    // Apply smooth opacity fade animation to lighting layers only
                    if (lightingRight && lightingRight !== torchRight) {
                        // this.applySmoothOpacityFade(lightingRight);

                        this.torchTweens.push(new TweenJS.Tween(lightingRight)
                        .to({alpha: 0.45}, 300)
                        .yoyo(true)
                        .repeat(Infinity)
                        .start());
                    }

                    if (lightingLeft && lightingLeft !== torchLeft) {
                        // this.applySmoothOpacityFade(lightingLeft);

                        this.torchTweens.push(new TweenJS.Tween(lightingLeft)
                        .to({alpha: 0.45}, 300)
                        .yoyo(true)
                        .repeat(Infinity)
                        .start());
                    }
                // });
            }
    }

    public static clearTorchTweens() {
        for(let tween of this.torchTweens) {
            tween.stop();
            TweenJS.remove(tween);
        }
        this.torchTweens = [];
    }

    // Helper method: Apply smooth opacity fade in/out effect (~3 cycles per second)
    private static applySmoothOpacityFade(sprite: PIXI.Sprite): void {
        const cycleDuration = 300;
        const startTime = Date.now();

        const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = (elapsed % cycleDuration) / cycleDuration;


            const sineWave = Math.sin(progress * Math.PI * 2);
            sprite.alpha = 0.65 + (sineWave * 0.35);

            requestAnimationFrame(animate);
        };

        animate();
    }

    private onLayoutChange = () => {
        setTimeout(() => {
            const point = Layers.CelebrationBackground.globalToLocal(new Point(canvasManager.stageWidth / 2 + canvasManager.stageOffsetX, canvasManager.stageHeight / 2));
            RevolverWinTransitions.glowContainer.position.set(point.x, point.y);
        }, 1);
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
            parallel([
                () => Contract.wrap(() => { soundManager.customEvent("plaque_transition") }),
                () => Zoom(Layers.Prompts.container, 1, 0, 200, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.5)),
                // () => Zoom(Layers.CelebrationBackground.container, 1, 0, 250, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.5))
                () => this.zoomOutBaseStacks(),
            ]).then(() => resolve(null));
        });
    }


}